export default "__VITE_PUBLIC_ASSET__dc6e51bd__"